import { render, staticRenderFns } from "./ProductCreateBulk.vue?vue&type=template&id=bbe594ee&scoped=true"
import script from "./ProductCreateBulk.vue?vue&type=script&lang=js"
export * from "./ProductCreateBulk.vue?vue&type=script&lang=js"
import style0 from "./ProductCreateBulk.vue?vue&type=style&index=0&id=bbe594ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbe594ee",
  null
  
)

export default component.exports